/*
  WARNING: Don't edit theses statuses willy-nilly.
*/
export enum StudentPathStatuses {
  PLANS_TO_APPLY = 'Plans to apply',
  APPLIED = 'Applied',
  APPLIED_WITH_SPECIAL_OPP = 'Applied w. special opportunity',
  WAITLISTED = 'Waitlisted',
  DENIED = 'Denied',
  ACCEPTED = 'Accepted',
  ACCEPTED_WITH_SPECIAL_OPP = 'Accepted w. special opportunity',
  COMMITTED = 'Committed',
  COMMITTED_WITH_SPECIAL_OPP = 'Committed w. special opportunity',
  DEFAULT = 'Plans to apply',
}

export const StudentPathCareerTypes = {
  JOB_TRAINING: 'Job training',
  CERTIFICATION_PROGRAM: 'Certification program',
  APPRENTICESHIP: 'Apprenticeship',
  MILITARY: 'Military',
  PUBLIC_SERVICE: 'Public service',
  OTHER: 'Other',
};

export const STUDENT_PATH_DEFAULT_STATUS = StudentPathStatuses.DEFAULT;

export const COLLEGE_PATH_STATUSES = {
  PLANS_TO_APPLY: StudentPathStatuses.PLANS_TO_APPLY,
  APPLIED: StudentPathStatuses.APPLIED,
  APPLIED_WITH_SPECIAL_OPP: StudentPathStatuses.APPLIED_WITH_SPECIAL_OPP,
  ACCEPTED: StudentPathStatuses.ACCEPTED,
  ACCEPTED_WITH_SPECIAL_OPP: StudentPathStatuses.ACCEPTED_WITH_SPECIAL_OPP,
  WAITLISTED: StudentPathStatuses.WAITLISTED,
  DENIED: StudentPathStatuses.DENIED,
  COMMITTED: StudentPathStatuses.COMMITTED,
  COMMITTED_WITH_SPECIAL_OPP: StudentPathStatuses.COMMITTED_WITH_SPECIAL_OPP,
};

export const CAREER_PATH_STATUSES = {
  PLANS_TO_APPLY: StudentPathStatuses.PLANS_TO_APPLY,
  APPLIED: StudentPathStatuses.APPLIED,
  ACCEPTED: StudentPathStatuses.ACCEPTED,
  DENIED: StudentPathStatuses.DENIED,
  COMMITTED: StudentPathStatuses.COMMITTED,
};

export const STUDENT_PATH_APPLIED_STATUSES = {
  APPLIED: StudentPathStatuses.APPLIED,
  APPLIED_WITH_SPECIAL_OPP: StudentPathStatuses.APPLIED_WITH_SPECIAL_OPP,
  WAITLISTED: StudentPathStatuses.WAITLISTED,
  DENIED: StudentPathStatuses.DENIED,
  ACCEPTED: StudentPathStatuses.ACCEPTED,
  ACCEPTED_WITH_SPECIAL_OPP: StudentPathStatuses.ACCEPTED_WITH_SPECIAL_OPP,
  COMMITTED: StudentPathStatuses.COMMITTED,
  COMMITTED_WITH_SPECIAL_OPP: StudentPathStatuses.COMMITTED_WITH_SPECIAL_OPP,
};

export const STUDENT_PATH_RESPONSE_STATUSES = {
  WAITLISTED: StudentPathStatuses.WAITLISTED,
  DENIED: StudentPathStatuses.DENIED,
  ACCEPTED: StudentPathStatuses.ACCEPTED,
  ACCEPTED_WITH_SPECIAL_OPP: StudentPathStatuses.ACCEPTED_WITH_SPECIAL_OPP,
  COMMITTED: StudentPathStatuses.COMMITTED,
  COMMITTED_WITH_SPECIAL_OPP: StudentPathStatuses.COMMITTED_WITH_SPECIAL_OPP,
};

export const STUDENT_PATH_ACCEPTANCE_STATUSES = {
  ACCEPTED: StudentPathStatuses.ACCEPTED,
  ACCEPTED_WITH_SPECIAL_OPP: StudentPathStatuses.ACCEPTED_WITH_SPECIAL_OPP,
  COMMITTED: StudentPathStatuses.COMMITTED,
  COMMITTED_WITH_SPECIAL_OPP: StudentPathStatuses.COMMITTED_WITH_SPECIAL_OPP,
};

export const STUDENT_PATH_FINAL_DECISION_STATUSES = {
  COMMITTED: StudentPathStatuses.COMMITTED,
  COMMITTED_WITH_SPECIAL_OPP: StudentPathStatuses.COMMITTED_WITH_SPECIAL_OPP,
};

export const STUDENT_PATH_GROUP = {
  NEED_TO_APPLY: 'Need to apply',
  NEED_FINAL_DECISION: 'Need final decision',
  COMMITTED: 'Committed',
};
